import { createContext, useEffect, useState } from "react";

export const LanguageContext = createContext();

const DEFAULT_LANG = "en";
const SUPPORTED_LANGS = ["en", "ar", "ku"];
const RTL_LANGS = ["ar", "ku"];

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    const saved = localStorage.getItem("lang");
    return SUPPORTED_LANGS.includes(saved) ? saved : DEFAULT_LANG;
  });

  useEffect(() => {
    localStorage.setItem("lang", currentLang);

    const isRTL = RTL_LANGS.includes(currentLang);

    document.documentElement.setAttribute(
      "dir",
      isRTL ? "rtl" : "ltr"
    );
    document.documentElement.setAttribute(
      "lang",
      currentLang
    );
  }, [currentLang]);

  const changeLanguage = (lang) => {
    if (!SUPPORTED_LANGS.includes(lang)) return;
    setCurrentLang(lang);
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLang,
        changeLanguage,
        isRTL: RTL_LANGS.includes(currentLang),
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
